var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('quillEditor',_vm._g(_vm._b({attrs:{"options":_vm.editorOption}},'quillEditor',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }